import Home from '../views/Home.vue'

const routes = [

	 // // 1. 所有旧路径重定向到 /index
	 //     {
	 //         path: '/contact',
	 //         redirect: '/index'
	 //     },
	 //     {
	 //         path: '/about',
	 //         redirect: '/index'
	 //     },
	 //     {
	 //         path: '/portfolio-1',
	 //         redirect: '/index'
	 //     },
	 //     {
	 //         path: '/portfolio-1-1',
	 //         redirect: '/index'
	 //     },
	 //     // 如果还有其他路径需要重定向，可以继续添加
	     
	 //     // 2. 根路径重定向到 /index
	 //     {
	 //         path: '/',
	 //         redirect: '/index'
	 //     },
	     
	 //     // 3. 唯一可访问的页面 - /index (使用 Index.vue)
	 //     {
	 //         path: '/index',
	 //         name: 'HomeIndex',
	 //         component: () => import(/* webpackChunkName: "contact" */ '../views/Index.vue')
	 //     }
	
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/about',
		name: 'About',
		// 路由级别的代码分割
		// 这会为这个路由生成一个单独的块 (about.[hash].js)
		component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
	},
	{
		path: '/founder',
		name: 'Founder',
		component: () => import( /* webpackChunkName: "founder" */ '../views/Founder.vue')
	},
	{
		path: '/contact',
		name: 'Contact',
		component: () => import( /* webpackChunkName: "founder" */ '../views/Contact.vue')
	},
	{
		path: '/projects',
		name: 'Projects',
		component: () => import( /* webpackChunkName: "projects" */ '../views/Projects.vue')
	},
	{
		path: '/materials',
		name: 'Materials',
		component: () => import( /* webpackChunkName: "materials" */ '../views/Materials.vue')
	},
	{
		path: '/stories',
		name: 'Stories',
		component: () => import( /* webpackChunkName: "stories" */ '../views/Stories.vue')
	}
]

export default routes